import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type DownArrowProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function DownArrowIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: DownArrowProps) {
  return (
     <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M10 10.977l4.125-4.125 1.178 1.178L10 13.333 4.697 8.03l1.178-1.178L10 10.977z"
        fill="#1A202C"
        className={pathClassName}
      />
    </Svg>
  );
}

export default DownArrowIcon;
